var React = require('react');

function Adi (props) {
    return React.createElement("svg",props,[React.createElement("defs",{"key":0},React.createElement("style",null,"\n\t\t\t.a {\n\t\t\tfill: #ec008c;\n\t\t\t}\n\t\t\t\n\t\t\t.i {\n\t\t\tfill: #fff200;\n\t\t\t}\n\t\t\t\n\t\t\t.d {\n\t\t\tfill: #00aeef;\n\t\t\t}\n\t\t")),React.createElement("rect",{"className":"a","x":"200","width":"100","height":"200","key":1}),React.createElement("circle",{"className":"a","cx":"300","cy":"100","r":"100","key":2}),React.createElement("rect",{"className":"d","y":"100","width":"200","height":"100","key":3}),React.createElement("circle",{"className":"d","cx":"100","cy":"100","r":"100","key":4}),React.createElement("rect",{"className":"i","x":"400","width":"100","height":"200","key":5})]);
}

Adi.defaultProps = {"width":"500","height":"200","viewBox":"0 0 500 200"};

module.exports = Adi;

Adi.default = Adi;
